exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#shop-events .customBtn img {\n  width: 100%;\n  height: 130px;\n  margin: 20px auto;\n}\n#shop-events .centered {\n  white-space: normal;\n  width: 150%;\n  font-size: 1.6em;\n}\n", ""]);

// exports
